import React from 'react';

function CollabTeaser() {
  return (
    <section className="collab-section" id="collab">
      <div className="collab-content">
        <h2 className="section-title">The Workshop</h2>
        <p>Collaborative builds. Shared blueprints. Community-driven craft.</p>
        <div className="collab-features">
          <div className="collab-feature">
            <span>🤝</span>
            <h4>Joint Projects</h4>
          </div>
          <div className="collab-feature">
            <span>📐</span>
            <h4>Shared Plans</h4>
          </div>
          <div className="collab-feature">
            <span>🏆</span>
            <h4>Community Votes</h4>
          </div>
        </div>
        <p className="coming-soon">Coming Soon</p>
      </div>
    </section>
  );
}

export default CollabTeaser;
